import { forwardRef, ReactElement, ReactNode } from 'react';
import styles from './ui-table-header-cell.module.scss';
import { UIIcon, UIText, UITooltip } from '../..';
import { charcoal } from '../../styles';

export type UITableSortDirection = 'asc' | 'desc';

export type UITableHeaderCellProps = {
    text: string;
    leftNode?: ReactNode | undefined;
    tooltip?: string;
    sortable?: boolean;
    sortDirection?: UITableSortDirection;
    onClick?: (sortDirection: UITableSortDirection) => void;
    className?: string | undefined;
};

export const UITableHeaderCell = forwardRef<
    HTMLTableCellElement,
    UITableHeaderCellProps
>((props: UITableHeaderCellProps, ref): ReactElement => {
    const { sortable = false, onClick, sortDirection, className } = props;

    const allClassNames = [styles.container];
    if (sortable) {
        allClassNames.push(styles.sortable);
    }

    if (className) {
        allClassNames.push(className);
    }

    function handleClick() {
        if (sortable && onClick) {
            if (sortDirection === 'asc') {
                onClick('desc');
            } else {
                onClick('asc');
            }
        }
    }

    return (
        <th ref={ref} className={allClassNames.join(' ')} onClick={handleClick}>
            <Inner {...props} />
        </th>
    );
});

function Inner(props: UITableHeaderCellProps): ReactElement {
    const { text, leftNode, tooltip, sortable, sortDirection } = props;
    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                gap: 4
            }}
        >
            {leftNode && leftNode}
            <UIText>{text}</UIText>
            {tooltip && (
                <UITooltip text={tooltip} place="right">
                    <UIIcon name="help-circle" size={12} color={charcoal} />
                </UITooltip>
            )}
            {sortable && sortDirection === 'asc' && (
                <UIIcon name="arrow-down" size={12} color={charcoal} />
            )}
            {sortable && sortDirection === 'desc' && (
                <UIIcon name="arrow-up" size={12} color={charcoal} />
            )}
        </div>
    );
}
